<h1 mat-dialog-title>Some features are blocked</h1>
<div mat-dialog-content>
  It looks like your browser is blocking tools we use for onboarding and support. <br />
  <br />
  To access tutorials, product guides, and live chat, please allow INSCYD in your ad blocker.
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Dismiss</button>
</div>
